module.exports = __webpack_public_path__ + "img/sashimiohnehintergrund.9d124004.png";